import { List, Modal, Typography, message } from "antd";
import { useEffect, useState } from "react";
import http from "../../../../../../services/http";
const { Text } = Typography;

const ModalParticipantes = ({ id, onClose }) => {
  const [participantes, setParticipantes] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id > 0) {
      listarParticipantes(id);
    }
  }, [id]);

  const listarParticipantes = async (id) => {
    if (!id) return;
    setLoading(true);
    setOpen(true);
    const api = await http("get", `v1/problemas_acoes/listar_participantes/${id}`, []);
    if (api.statusCode === 200) {
      setParticipantes(api?.response?.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  return (
    <Modal
      title={"Participantes"}
      open={open}
      cancelText="Fechar"
      width={500}
      okButtonProps={{ style: { display: "none" } }}
      cancelButtonProps={{ size: "large", loading: loading }}
      onCancel={() => {
        setOpen(false);
        onClose();
      }}>
      <List
        pagination={{ size: "small" }}
        dataSource={participantes}
        loading={loading}
        renderItem={(item) => (
          <List.Item style={{ padding: 5 }}>
            <Text> {item?.nome} </Text>
          </List.Item>
        )}
      />
    </Modal>
  );
};

export { ModalParticipantes };
